import { render, staticRenderFns } from "./pricingThree.vue?vue&type=template&id=5d6436f1&"
import script from "./pricingThree.vue?vue&type=script&lang=js&"
export * from "./pricingThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports